export function clamp(v:number,min:number,max:number){return Math.max(min,Math.min(max,v));}
export function distanceSq(ax:number,ay:number,bx:number,by:number){const dx=ax-bx,dy=ay-by;return dx*dx+dy*dy;}
export function formatMonth(year:number,month:number){return ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'][(month-1+12)%12]+' '+year;}
